import { Icons } from '@/components/Shares/Icons';
import type { RewardsRankItemType } from '@/types';
import { Card, Group, Image, Text } from '@mantine/core';
export const RewardsRankItem: React.FC<RewardsRankItemType> = ({
  rankImg,
  text,
  success
}) => {
  return <Card bg="var(--navbar-bg-color)" p={{
    base: 10,
    sm: 14
  }} radius={5}>
      <Group justify="space-between">
        <Group gap={10}>
          <Image src={rankImg} alt="rank" w={36} h={36} />
          <Text fz={13} fw={700} tt="uppercase" c="var(--text-dark)">
            {text}
          </Text>
        </Group>
        {success ? <Icons className="icon-pr-line-checked-circle-broken" fontSize={24} color="var(--mantine-color-prime-0)" /> : <Icons className="icon-pr-line-lock" fontSize={24} color="var(--mantine-color-prime-13)" />}
      </Group>
    </Card>;
};